<div
  class="dropdown-menu"
  [class.dropdown-menu--highlight-selected]="highlightSelected"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown)="onKeydown($event)"
>
  <ul class="dropdown-menu__options">
    <li
      class="dropdown-menu__option"
      *ngFor="let option of options; trackBy: trackBy; let i = index"
    >
      <button
        class="dropdown-option"
        [class.dropdown-option--selected]="option.value === currentOption.value"
        [class.dropdown-option--focused]="
          i === focusKeyManager?.activeItemIndex
        "
        (click)="select(option)"
        (mousemove)="focusButton(i)"
        libListButton
      >
        {{ option.text | i18n }}
      </button>
    </li>
  </ul>
</div>
